import angular from "angular";
import appConfig from '../ConfigModule/ConfigModule';
import loaderManager from '../Loader/LoaderManager';

let LoaderInterceptor = function (CONFIG, LoaderManager, $q) {
    /** @ngInclude */

    let pendingRequests = 0;

    let addPending = function () {
        pendingRequests++;
        LoaderManager.setActive('global');
    };

    let removePending = function () {
        pendingRequests -= 1;
        if (pendingRequests === 0) {
            LoaderManager.setActive('global', false);
        }
    };

    return {
        request: function (config) {
            addPending();
            return config;
        },
        response: function (response) {
            removePending();
            return response;
        },
        responseError: function (rejection) {
            removePending();
            return $q.reject(rejection);
        }

    };
};

export default angular.module('cms.loader.interceptor', [appConfig, loaderManager]).factory('LoaderInterceptor', LoaderInterceptor).name;


// WEBPACK FOOTER //
// ./src/cmsCore/Loader/LoaderInterceptor.js